/**
 * /logged-out — post-IDP-logout splash.
 */

import { useNavigate } from 'react-router-dom';
import { Logo } from '../components/brand';

export function LoggedOut() {
  const navigate = useNavigate();
  return (
    <div className="bm-dock">
      <div className="bm-dock-grid" aria-hidden />
      <div className="bm-dock-vignette" aria-hidden />
      <main className="bm-dock-panel">
        <div className="bm-dock-mark">
          <Logo size={56} accent="var(--bm-text-faint)" />
        </div>
        <h1 className="bm-dock-title" style={{ fontSize: 36 }}>
          Signed out
        </h1>
        <p className="bm-dock-tagline">
          <span className="muted">Your session ended. Token revoked.</span>
        </p>
        <div className="bm-dock-cta">
          <button
            type="button"
            className="bm-btn bm-btn-primary bm-btn-pill bm-btn-lg"
            onClick={() => navigate('/')}
          >
            Back to dock
          </button>
        </div>
      </main>
      <footer className="bm-dock-footer mono">
        <span style={{ color: 'var(--bm-text-faint)' }}>CLOUDFLARE PAGES · WORKERS · D1 · R2</span>
      </footer>
    </div>
  );
}
